module.exports = __webpack_public_path__ + "img/lamps-sprite-2x.3e6bb897.png";